import React from "react";
import { useLanguage } from "../../Providers/LanguageContext";
import SignUpButton from "./SignUpButton";
import iMg1 from "../../images/Uso Personal y Doméstico_3-76.png";
import iMg2 from "../../images/Uso Personal y Doméstico_1-74.png";
import iMg3 from "../../images/Uso Personal y Doméstico_2-75.png";
import iMg4 from "../../images/Uso Personal y Doméstico_4 .png";
import iMg5 from "../../images/Uso Personal y Doméstico_5 .png";
import iMg6 from "../../images/Uso Personal y Doméstico_6-81.png";
import iMg7 from "../../images/Uso Personal y Doméstico_7 INGLES.png";
import iMg7es from "../../images/Uso Personal y Doméstico_1 copia 3.png";
import bodyimage from "../../images/fondo.png";
import tick from "../../images/tick.png";
import SignUpButton2 from "./SignUpButton2";
import './IndustrySolution.css'
import circle from '../../images/Ellipse 17.png'
import laptop from '../../images/image 8.png'
import dollar from '../../images/image 9.png'
import trading from '../../images/image 10.png'
import file from '../../images/image 11.png'
import circle2 from '../../images/Ellipse 18.png'
import signup from '../../images/image 13.png'
import UserBanner from "./UserBanner";
import guysitting from '../../images/image 15.png'
const PersonalUse = () => {
  const { language, currentLanguage } = useLanguage();
  const personal= true;
  return (
    <>

      <section
        id="agriculture_sec"
        className="banking d-none"
        style={{ backgroundImage: `url('${bodyimage}')`, position: "relative", paddingBottom: "0" }}
      >
        <div className="container">
          <div className="agriculture_head" style={{ marginBottom: "0" }}>
            <h3 style={{ color: "#0e2537" }}>
              {language.fisi_key_benifits}
            </h3>
          </div>
          <div className="row mb-5" >
            <div className="col-md-6 col-12">
              <div className="agriculture_headtext">
                <h5>
                  {language.personal_and_household}
                </h5>
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.budgeting}
                    </h4>
                    <p>
                      {language.fisi_create_person_budget}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg2} className="img-fluid" alt="" />
              </div>
            </div>
          </div>

          <div className="col-md-12 col-12 rightsideGap">
            <div className="agriculture_headtext">
              <div className="tickpara">
                <div className="tick">
                  <img src={tick}></img>
                </div>
                <div>
                  <h4 style={{ color: "#333333" }}>{language.bill_tracking}</h4>
                  <p>
                    {language.fisi_user_track_bill}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-5" style={{ alignItems: "center" }}>
            <div className="col-md-7 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>{language.financial_goal_setting}</h4>
                    <p>
                      {language.fisi_financial_goal}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-5 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg3} className="img-fluid" alt="" />
              </div>
            </div>
          </div>

          <div className="row mb-5" style={{ alignItems: "center" }}>
            <div className="col-md-4 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg1} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-md-8 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.automated_expence_track}
                    </h4>
                    <p>
                      {language.fisi_automatically_cata}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-8 col-12">
            <div className="agriculture_headtext">
              <div className="tickpara">
                <div className="tick">
                  <img src={tick}></img>
                </div>
                <div>
                  <h4 style={{ color: "#333333" }}>
                    {language.investment_tracking}
                  </h4>
                  <p>
                    {language.fisi_invest_trackibg}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-5" style={{ alignItems: "center" }}>
            <div className="col-md-4 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg4} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-md-8 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.net_worth_tracking}
                    </h4>
                    <p>
                      {language.fisi_track_worth}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-5" style={{ alignItems: "center" }}>
            <div className="col-md-8 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.mobile_access}
                    </h4>
                    <p>
                      {language.fisi_available_desktop}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg5} className="img-fluid" alt="" />
              </div>
            </div>
          </div>

          <div className="col-md-12 col-12 rightsideGap">
            <div className="agriculture_headtext">
              <div className="tickpara">
                <div className="tick">
                  <img src={tick}></img>
                </div>
                <div>
                  <h4 style={{ color: "#333333" }}>
                    {language.secure_data_storage}
                  </h4>
                  <p>
                    {language.fisi_bank_encryption}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-5" style={{ alignItems: "center" }}>
            <div className="col-md-8 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.personalized_insights}
                    </h4>
                    <p>
                      {language.fisi_person_insight}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg6} className="img-fluid" alt="" />
              </div>
            </div>
          </div>

          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-md-5 col-12 m-auto">
              <div className="agriculture_img">
                {
                  currentLanguage === 'spanish'
                    ?
                    <img src={iMg7es} className="img-fluid" alt="" />
                    :
                    <img src={iMg7} className="img-fluid" alt="" />
                }
                {/* <div
                  className="registrarAnddescargar"
                  style={{
                    transform: "translate(-50% , -50%)",
                    top: "44%",
                    left: "21%",
                    flexDirection: "column",
                  }}
                >
                  <button
                    className="registrar_Btn"
                    style={{
                      background:
                        " linear-gradient(to right, #18465d 1%,#0f283b 100%,#2989d8 100%)",
                      border: "0",
                      marginBottom: "20px",
                    }}
                  >
                    Registrarse
                  </button>
                  <button className="descargar_Btn">Descargar</button>
                </div> */}
                <SignUpButton2 />
              </div>
            </div>
            <div className="col-md-7 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.user_friendly_interface}
                    </h4>
                    <p>
                      {language.fisi_user_interface}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="general_user_wrapper">
        <UserBanner personal = {personal} />
        <div className="general_user_management_all_content_wrapper">
          <div className="general_financial_management_Wrapper">
            <div className="circle_img_1">
              <img className="cirle_svg_1" src={circle} />
            </div>
            <div className="container-fluid financial_management_content_wrapper">
              <div className="financial_management_left">
                <h1> {language.budgeting}</h1>
                <p>   {language.fisi_create_person_budget}</p>
              </div>
              <div className="financial_management_right">
                <img src={laptop} />
              </div>
            </div>
          </div>



          <div className="general_financial_management_Wrapper" >

            <div className="container-fluid financial_management_content_wrapper">

              <div className="financial_management_right">
                <img src={dollar} />
              </div>


              <div className="financial_management_left">
                <h1>{language.bill_tracking}</h1>
                <p>{language.fisi_user_track_bill}</p>
              </div>
            </div>
          </div>



          <div className="general_financial_management_Wrapper" style={{
            padding: '0px 0px'
          }}>
            <img className="cirle_svg_2" src={circle2} style={{
              width: '350px',
              height: '350px',
              position: "absolute",
              top: '0',
              right: '0'
            }} />
            <div className="container-fluid financial_management_content_wrapper">




              <div className="financial_management_left">
                <h1>{language.financial_goal_setting}</h1>
                <p>   {language.fisi_financial_goal}</p>
              </div>



              <div className="financial_management_right" style={{
                zIndex: 9
              }}>
                <img src={trading} />
              </div>


            </div>
          </div>



          <div className="general_financial_management_Wrapper" style={{
            padding: '0px 0px'
          }}>
            {/* <img className="cirle_svg_3" src={circle2} style={{
          position:'absolute',
          bottom:'-100px',
          left:'50px',
          width:'300px',
          height:'300px'
        }}/> */}
            <div className="container-fluid financial_management_content_wrapper">



              <div className="financial_management_right">
                <img src={file} style={{
                  width: '80%'
                }} />
              </div>
              <div className="financial_management_left">
                <h1>  {language.automated_expence_track}</h1>
                <p>   {language.fisi_automatically_cata} </p>
              </div>






            </div>
          </div>


          <div className="general_financial_management_Wrapper" style={{
            padding: '0px 0px'
          }}>
            {/* <img className="cirle_svg_3" src={circle2} style={{
              position: 'absolute',
              bottom: '-100px',
              left: '50px',
              width: '300px',
              height: '300px'
            }} /> */}
            <div className="container-fluid financial_management_content_wrapper">

              <div className="financial_management_left">
                <h1>  {language.investment_tracking}</h1>
                <p>{language.fisi_invest_trackibg}</p>
              </div>

              <div className="financial_management_right">
                <img src={signup} />
              </div>







            </div>
          </div>

          <div className="general_financial_management_Wrapper" style={{
            padding: '0px 0px'
          }}>
            {/* <img className="cirle_svg_3" src={circle2} style={{
              position: 'absolute',
              bottom: '-100px',
              left: '50px',
              width: '300px',
              height: '300px'
            }} /> */}
            <div className="container-fluid financial_management_content_wrapper">

              {/* <div className="financial_management_left">
                <h1>  {language.investment_tracking}</h1>
                <p>{language.fisi_invest_trackibg}</p>
              </div> */}
              <div className="financial_management_right"></div>
              <div className="financial_management_left">
                <h1>  {language.net_worth_tracking}</h1>
                <p>    {language.fisi_track_worth}</p>
              </div>







            </div>
          </div>


          <div className="general_financial_management_Wrapper" style={{
            padding: '30px 0px'
          }}>
            <img className="cirle_svg_3" src={circle2} style={{
              position: 'absolute',
              bottom: '-100px',
              left: '50px',
              width: '300px',
              height: '300px'
            }} />
            <div className="container-fluid financial_management_content_wrapper">

              <div className="financial_management_left">
                <h1>  {language.mobile_access}</h1>
                <p>      {language.fisi_available_desktop}</p>
              </div>
              <div className="financial_management_right"></div>








            </div>
          </div>



          <div className="general_financial_management_Wrapper" style={{
            padding: '30px 0px'
          }}>

            <div className="container-fluid financial_management_content_wrapper">
              <div className="financial_management_right"></div>
              <div className="financial_management_left">
                <h1>   {language.secure_data_storage}</h1>
                <p>      {language.fisi_bank_encryption}</p>
              </div>









            </div>
          </div>



          <div className="general_financial_management_Wrapper" style={{
            padding: '30px 0px'
          }}>

            <div className="container-fluid financial_management_content_wrapper">
              <div className="financial_management_left">
                <h1>{language.personalized_insights}</h1>
                <p>{language.fisi_person_insight}</p>
              </div>
              <div className="financial_management_right"></div>










            </div>
          </div>


          <div className="general_financial_management_Wrapper" style={{
            padding: '30px 0px'
          }}>

            <div className="container-fluid financial_management_content_wrapper">
              <div className="financial_management_right">
                <img src={guysitting}/>
              </div>
              <div className="financial_management_left">
                <h1>  {language.user_friendly_interface}</h1>
                <p>  {language.fisi_user_interface}</p>
              </div>
            










            </div>
          </div>

        </div>

      </div>


    </>
  );
};

export default PersonalUse;
